var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9376 3.49712C18.109 1.68318 15.6779 0.684204 13.0921 0.684204C10.5062 0.684204 8.07508 1.68318 6.2466 3.49712C4.41812 5.31101 3.41107 7.72274 3.41107 10.2879C3.41107 12.6333 4.25328 14.8499 5.79502 16.5991L0.418539 21.9327C0.160292 22.1889 0.160292 22.6042 0.418539 22.8605C0.547663 22.9885 0.716907 23.0526 0.886107 23.0526C1.05531 23.0526 1.2246 22.9886 1.35368 22.8604L6.7302 17.5268C8.49341 19.0562 10.7279 19.8918 13.0921 19.8918C15.678 19.8918 18.109 18.8928 19.9375 17.0788C21.766 15.265 22.773 12.8532 22.773 10.288C22.773 7.72274 21.766 5.31101 19.9376 3.49712ZM19.0023 16.1511C15.7434 19.3841 10.4408 19.3841 7.18182 16.1511C3.9229 12.9182 3.9229 7.65782 7.18182 4.42488C8.81146 2.80824 10.9514 2.00018 13.0921 2.00018C15.2323 2.00018 17.3731 2.80863 19.0024 4.42488C22.2612 7.65777 22.2612 12.9181 19.0023 16.1511Z",
    fill: "#C6C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch2);
export default __webpack_public_path__ + "static/media/search-2.730af108ca7182704b01a23743a0abba.svg";
export { ForwardRef as ReactComponent };